import {Countries as countries} from './CountryList';
import parsePhoneNumber from 'libphonenumber-js';
import Cookies from 'universal-cookie';
 
const cookies = new Cookies();
const emailRegex = new RegExp("^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$");
const simpleEmailRegex = /^.+@.+$/;
const alphanumeric = /^[a-z0-9]+$/i;
const alphanumericWithSpace = /^[a-z0-9 ]+$/i;
const alphanumericWithSymbol = /^[a-z0-9-_,.+():;/&]+$/i;
const alphanumericWithSymbolAndSpace = /^[a-z0-9-_,.+():'`;/& ]+$/i;
const alphabet = /^[a-z]+$/i;
const alphabetWithSpace = /^[a-z ]+$/i;

export function isEmail(email) {
    // writing a regex to match all valid email addresses is really, really hard (see http://stackoverflow.com/a/201378)
    // so we just do a simple check and rely on a verification email to tell if it's a real address
    return emailRegex.test(email);
}

export function isAlphanumericWithSymbols(text, allowSpace) {
    if (allowSpace) {
        return alphanumericWithSymbolAndSpace.test(text);
    } else {
        return alphanumericWithSymbol.test(text);
    }
}

export function isAlphanumeric(text, allowSpace) {
    if (allowSpace) {
        return alphanumericWithSpace.test(text);
    } else {
        return alphanumeric.test(text);
    }
}

export function isAlphabet(text, allowSpace) {
    if (allowSpace) {
        return alphabetWithSpace.test(text);
    } else {
        return alphabet.test(text);
    }
}

export function parseCountry (code, label) {
    let result=  countries.find(  v=> (v.code === code || v.label === label));
    return result;
}

export function parsePhone (country, area, phone) {

    let countryText = country == 0 ? '': `${country}`;
    let areaText = area == 0 ? '': `${area}`;
    let phoneText = phone == 0 ? '': `${phone}`;

    return countryText + areaText + phoneText;

}

export function formatPhoneNumber(phoneText) {
    let phone = phoneText;
    if (phone && phone.length > 0 ) {
        
        if (!phone.startsWith('+')) {
            phone = '+' + phone;
        }

        const phoneNumber = parsePhoneNumber(phone);
        if (phoneNumber && phoneNumber.isPossible()) {
            return `(${phoneNumber.country? phoneNumber.country: 'unknown'}) ${phoneNumber.format("INTERNATIONAL")}`;
        }
    }

    return phone;

}

export function getDefaultLang() {

    let browserLocale = cookies.get("lang") || navigator.language;
    const check = browserLocale.toLowerCase();
    if(check === 'zh-tw' || check === 'zh-hk' || check === 'zh' || check === 'zh-mo' || check === 'zh-hant' || check === 'zhtw') {
        browserLocale = 'zhTW';
    } else if (check === 'zh-sg' || check === 'zh-cn' || check === 'zh-hans' || check === 'zhcn' ) {
        browserLocale = 'zhCN';
    } else {
        browserLocale = 'en'
    }

    return browserLocale;

}

export function setCookie(key, value) {
    cookies.set(key, value);
}
export function getCookie(key, defaultValue) {
    return cookies.get(key) || defaultValue;
}